import React from "react";
import { useNavigate } from "react-router-dom";
import "./search.css";

const SearchResults = ({ results, onClose, isVisible }) => {
  const navigate = useNavigate();

  const handleProductClick = (product) => {
    onClose();
    navigate(`/ProductDetails/${product.id}`, { state: { product } });
    console.log("Product clicked:", product);
  };

  const normalizedResults = results.map((product) => ({
    id: product.id,
    item_name: product.item_name || product.title,
    itemPhotos:
      Array.isArray(product.itemPhotos) && product.itemPhotos.length > 0
        ? product.itemPhotos[0]
        : typeof product.itemPhotos === "string" && product.itemPhotos
        ? product.itemPhotos
        : Array.isArray(product.main_img) && product.main_img.length > 0
        ? product.main_img[0]
        : typeof product.main_img === "string" && product.main_img
        ? product.main_img
        : "",
    price: product.price || 0,
    description: product.description || "No description available",
    condition: product.condition || "no info",
    type: product.type || "no info",
  }));

  return (
    <div className={`search-results ${isVisible ? "active" : ""}`}>
      <div className="search-header">
        <h2>Search Results</h2>
        <button onClick={onClose}>Back to Products</button>
      </div>

      {normalizedResults.length === 0 ? (
        <p>No results found.</p>
      ) : (
        <div className="product-grid">
          {normalizedResults.map((product) => (
            <div className="product-cards" key={product.id}>
              <img
                src={product.itemPhotos}
                alt={product.item_name}
                onClick={() => handleProductClick(product)}
              />
              <h4>{product.item_name}</h4>

              <p>K{product.price}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SearchResults;
